<template>
	<div class="account-notifications">
						<span class="fa fa-bell-o">
							<!-- SVG ARROW -->
							<svg class="svg-arrow">
								<use xlink:href="#svg-arrow"></use>
							</svg>
							<!-- /SVG ARROW -->
						</span>

		<!-- PIN -->
		<span class="pin soft-edged primary" v-if="eventsUnread" v-text="eventsUnread"></span>
		<!-- /PIN -->

		<!-- DROPDOWN NOTIFICATIONS -->
		<ul class="dropdown notifications no-hover closed">
			<!-- DROPDOWN ITEM -->
			<div class="dropdown-triangle"></div>
			<li v-if="notifications.length" v-for="notification in notifications" :key="notification.id" :class="{ 'dropdown-item unread' : isUnread(notification), 'dropdown-item' : !isUnread(notification) }">

				<a :href="url(notification)"></a>
					<figure class="user-avatar">
                        <img :src="notification.data_object.avatar">
					</figure>
				<p class="text-header tiny title"><span v-text="notification.data_object.title"></span></p>

				<p class="title-full" v-text="notification.data_object.comment"></p>

                <p class="timestamp">{{notification.created_at | fromNowAgo }}</p>
                <span :class="{ 'notification-type secondary-new fa fa-flag-checkered' : isUnread(notification),
                				'notification-type fa fa-flag-checkered' : !isUnread(notification) }" v-if="notification.type === 'App\\Notifications\\OrderWasDelivered'"></span>
                <span :class="{ 'notification-type secondary-new fa fa fa-exclamation-circle' : isUnread(notification),
                				'notification-type fa fa-flag-checkered' : !isUnread(notification) }" v-if="notification.type === 'App\\Notifications\\RevisionWasDeclined'"></span>
				<span :class="{ 'notification-type secondary-new fa fa-ban' : isUnread(notification),
                				'notification-type fa fa-ban' : !isUnread(notification) }" v-if="notification.type === 'App\\Notifications\\OrderWasCanceled'"></span>

			</li>

			<li v-if="!notifications.length"  class="dropdown-item empty">
				<p class="text-header tiny title">You have 0 notifications</p>
				<p class="sub-title">Place an order and communicate with writer</p>
			</li>

			<a href="/customer/dashboard/notifications" class="button primary">View all Notifications</a>
			<!-- /DROPDOWN ITEM -->
		</ul>
		<!-- /DROPDOWN NOTIFICATIONS -->
	</div>
</template>


<script>

    export default {
        data () {
            return {
				dataSet: [],
                notifications: [],
                eventsUnread: false,
            }
		},

		created(){
			axios.get('/api/notifications?filter[unread]=true&filter[events]=true&count=6')
					.then(response => {
						this.dataSet = response.data;
						this.eventsUnread = response.data.total;
						this.notifications = response.data.data;
					});

		},


        methods: {
            isUnread: function (notification) {
                return notification.read_at == null
            },

			url: function (notification) {
				if(notification.type === 'App\\Notifications\\WriterNewsCreated') {
					return '/writer/news';
				}
				return '/orders/'+notification.data_object.hash_id;
			},
        },


    }
</script>